import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import SalesGraph from '@/components/SalesGraph';
import { actions } from '@/redux/reports/b2b/reducer';
import { dateFormat } from '@/helpers/dateFormat';
import { useCurrency } from '@/hooks/useCurrency';

import OrderCards from './OrderCards';
import Filters from '../Filters';
import InvoiceTable from './InvoiceTable';

const initialFilters = {};

const B2BStats = () => {
    const dispatch = useDispatch();
    const { icon: currencyIcon } = useCurrency();

    const supplierAndVendors = useSelector((state) => state.reports.b2b.supplierAndVendors);
    const b2bSales = useSelector((state) => state.reports.b2b.b2bSalesOverview);
    const invoices = useSelector((state) => state.reports.b2b.invoices);
    const totalInvoices = useSelector((state) => state.reports.b2b.totalInvoices);

    const [filters, baseSetFilters] = useState(initialFilters);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const setFilters = useCallback((name, value) => {
        baseSetFilters((prev) => ({ ...prev, [name]: value }));
    }, [baseSetFilters]);

    useEffect(() => {
        const data = {
            country_id: filters.country_id?.value,
            partner_type: filters.partner_type,
            start_date: filters.date?.[0].format(dateFormat),
            end_date: filters.date?.[1].format(dateFormat),
            page: currentPage,
            perPage: itemsPerPage,
        };
        dispatch(actions.requestGetB2bReports(data));
    }, [dispatch, filters, currentPage, itemsPerPage]);

    return (
        <Row gutter={[30, 30]} className="b2b-stats">
            <Col xs={24}>
                <Filters
                    type="b2b"
                    setFilters={setFilters}
                    currency={currencyIcon}
                />
            </Col>
            <Col xs={24}>
                <OrderCards
                    data={supplierAndVendors}
                    currency={currencyIcon}
                />
            </Col>
            <Col xs={24} md={10}>
                <SalesGraph data={b2bSales} currency={currencyIcon} />
            </Col>
            <Col xs={24} md={14}>
                <InvoiceTable
                    data={invoices}
                    totalItems={totalInvoices}
                    page={currentPage}
                    setPage={setCurrentPage}
                    perPage={itemsPerPage}
                    setPerPage={setItemsPerPage}
                    currency={currencyIcon}
                />
            </Col>
        </Row>
    );
};

export default B2BStats;
